module.exports = __webpack_public_path__ + "img/ic_store_trait_top_img6.2064ba8f.png";